var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 27,
    viewBox: "0 0 130 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F08319",
    d: "M31.1,26.4h-4.9V13H14.5v13.4H9.6V8.1 h21.5V26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M56.8,26.4H35.3V8.1h4.9v13.4h3.4V8.1 h4.9v13.4h3.4V8.1h4.9L56.8,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M82.5,26.4H61v-4.9h21.5V26.4z M82.5,19.7H61v-4.9h21.5V19.7z M82.5,13H61V8.1h21.5V13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M130.5,26.4h-6.4l-11.2-12v12h-4.9v-25 h4.9v6.7h16.6V13h-11.5L130.5,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M91.6,26.4h-4.9V8.1h17.1V13H91.6 L91.6,26.4L91.6,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F08319",
    d: "M5.4,26.4H0.5V8.1h4.9V26.4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_729_1375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 27,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.9fbdfddd3fbae40d871f323168d7d4b2.svg";